<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vejjOe/tc-custom/9780292788107.jpg?1713498322909" alt="This image is the cover for the book Native Plants for Southwestern Landscapes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Native Plants for Southwestern Landscapes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A guide to xeriscaping for eco-conscious gardeners living in desert climates.</b></p><p> For gardeners who want to conserve water, the color, fragrance, shade, and lush vegetation of a traditional garden may seem like a mirage in the desert. But such gardens can flourish when native plants grow in them. In this book, Judy Mielke, an expert on Southwestern gardening, offers the most comprehensive guide available to landscaping with native plants. Writing simply enough for beginning gardeners, while also providing ample information for landscape professionals, she presents over three hundred trees, shrubs, vines, grasses, groundcovers, wildflowers, cacti, and other native plants suited to arid landscapes. </p><p> The heart of the book lies in the complete descriptions and beautiful color photographs of plants native to the Mojave, Sonoran, and Chihuahuan desert regions of the Southwestern United States and northern Mexico. Mielke characterizes each plant and gives detailed information on its natural habitat, its water, soil, light, temperature, and pruning requirements, and its possible uses in landscape design. </p><p> In addition, Mielke includes informative discussions of desert ecology, growing instructions for native plants and wildflowers, and “how-to” ideas for revegetation of disturbed desert areas using native plants. She concludes the book with an extensive list of plants by type, including those that have specific features such as shade or fragrance. She also supplies a list of public gardens that showcase native plants. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judy Mielke
      </h2>
      
      <p class="authorDescription body article"> Judy Mielke of Tempe, Arizona, is a landscape designer who also teaches courses on the use of Southwestern native plants. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press, Austin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bb26c27e